module.exports = __webpack_public_path__ + "img/pin.44f74b4f.svg";